import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';

@Injectable()
export class SocialActivateGuard implements CanActivate {


    constructor(
        private currentUserState: CurrentUserStateService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.hasSocialAccess();
    }

}
